import React, { Component } from 'react';
import { get, set } from 'lodash';
import moment from 'moment/moment';
import { Table, OverlayTrigger, Popover, Row } from 'react-bootstrap';
import { Field } from 'redux-form';
import PropTypes from 'prop-types';

import VerbButton, { VERB_BUTTON_TYPE } from '../../../../../shared/components/VerbButton';
import HiddenInput from '../../../../../shared/components/formComponents/inputs/HiddenInput';
import DisplayOnlyInput from '../../../../../shared/components/formComponents/inputs/DisplayOnlyInput';
import VerbSelect from '../../../../../shared/components/formComponents/inputs/VerbSelect';

class LearningAssetLicensesTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            associatedCollectionsByTrackId: {}
        };
    }

    static propTypes = {
        getLearningAssetName: PropTypes.func,
        getLicensedDate: PropTypes.func,
        currentValues: PropTypes.object,
        fields: PropTypes.object,
        selectedLearningAssetId: PropTypes.string,
        availableLearningAssets: PropTypes.array,
        selectedLearningAsset: PropTypes.object,
        handleAssociatedCollectionsFetching: PropTypes.func.isRequired,
        handleLearningAssetChange: PropTypes.func,
        collectionLicensesByCollectionId: PropTypes.object,
        associatedCollectionsByTrackId: PropTypes.object.isRequired
    };

    _makeAssociatedCollectionsPopover = (learningAssetId, associatedCollectionsByTrackId) => {
        const { collectionLicensesByCollectionId } = this.props;
        const associatedCollections = associatedCollectionsByTrackId[learningAssetId];

        const associateCollectionsMessage = (
            <div className={'associate-entity-container'}>
                <Row>
                    <p className={'associated-entity'}>Associated collections:</p>
                </Row>
                {associatedCollections && associatedCollections.length > 0 ? (
                    associatedCollections.map((collection) => (
                        <Row key={collection._id}>
                            <p
                                className={'collection-name'}
                                style={collectionLicensesByCollectionId[collection._id] ? { color: '#16ABE2' } : {}}
                            >
                                - {collection.name}
                                {collectionLicensesByCollectionId[collection._id] ? ` [Licensed]` : null}
                            </p>
                        </Row>
                    ))
                ) : (
                    <Row>
                        <p className={'collection-name'}> None</p>
                    </Row>
                )}
            </div>
        );

        return (
            <Popover id={'archive-submission-popover'} className={'archive-submission-popover'}>
                {associateCollectionsMessage}
            </Popover>
        );
    };

    _renderTable = (fields) => {
        const {
            getLearningAssetName,
            getLicensedDate,
            handleAssociatedCollectionsFetching,
            currentValues,
            associatedCollectionsByTrackId
        } = this.props;
        if (fields && fields.length > 0) {
            return (
                <Table striped={false} bordered={false} hover={true}>
                    <thead>
                        <tr>
                            <th className={'buttonCell'}>Actions</th>
                            <th hidden>TrackId</th>
                            <th>Track Name</th>
                            <th>Added On</th>
                        </tr>
                    </thead>
                    <tbody>
                        {fields.map((member, index) => {
                            const trackId = get(currentValues, `${member}.trackId`, '');
                            const trackName = getLearningAssetName(trackId);
                            const associatedCollectionsPopover = this._makeAssociatedCollectionsPopover(
                                trackId,
                                associatedCollectionsByTrackId
                            );
                            if (trackName !== '') {
                                set(currentValues, `${member}.trackName`, trackName);
                            }

                            const licensedDateTime = getLicensedDate(member);

                            return (
                                <tr key={index}>
                                    <td className={'buttonCell'}>
                                        <VerbButton
                                            buttonType={VERB_BUTTON_TYPE.SECONDARY_DETAILS}
                                            fontAwesomeIcon={'fa-trash'}
                                            title={'Remove TrackLicense'}
                                            onClick={() => fields.remove(index)}
                                        />
                                        <OverlayTrigger
                                            trigger={'click'}
                                            placement={'bottom'}
                                            transition={false}
                                            rootClose
                                            overlay={associatedCollectionsPopover}
                                        >
                                            <VerbButton
                                                className={'archive-button'}
                                                buttonType={VERB_BUTTON_TYPE.SECONDARY_DETAILS}
                                                fontAwesomeIcon={'fa-info'}
                                                onClick={() => {
                                                    handleAssociatedCollectionsFetching(trackId);
                                                }}
                                            />
                                        </OverlayTrigger>
                                    </td>
                                    <td hidden>
                                        <Field name={`${member}.trackId`} component={HiddenInput} />
                                    </td>
                                    <td>
                                        <Field name={`${member}.trackName`} component={DisplayOnlyInput} />
                                    </td>
                                    <td>{licensedDateTime ? moment(licensedDateTime).format('MMM Do YYYY') : null}</td>
                                </tr>
                            );
                        })}
                    </tbody>
                </Table>
            );
        }
        return null;
    };

    render() {
        const {
            handleLearningAssetChange,
            selectedLearningAssetId,
            selectedLearningAsset,
            availableLearningAssets,
            fields
        } = this.props;
        return (
            <div>
                <div className={'row'}>
                    <div className={'col-8'}>
                        <VerbSelect
                            placeholder={'Select Learning Asset'}
                            className={'reactSelect'}
                            value={selectedLearningAssetId}
                            labelKey={'name'}
                            valueKey={'_id'}
                            onChange={handleLearningAssetChange}
                            options={availableLearningAssets}
                        />
                    </div>
                    <div className={'col-4'}>
                        <VerbButton
                            className={'full-width'}
                            fontAwesomeIcon={'fa-plus'}
                            disabled={!selectedLearningAssetId}
                            onClick={() =>
                                selectedLearningAssetId
                                    ? fields.push({
                                          trackId: selectedLearningAssetId,
                                          trackName: selectedLearningAsset.name,
                                          licensedDateTime: moment.utc()
                                      })
                                    : null
                            }
                        >
                            Add Learning Asset
                        </VerbButton>
                    </div>
                </div>
                {this._renderTable(fields)}
            </div>
        );
    }
}

export default LearningAssetLicensesTable;
